(function() {
  var defaultSelector = '[data-mx-stagger-reveal]';
  var preparedItems = new WeakSet();
  var animatedItems = new WeakSet();

  function isVisible(element) {
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  function getDuration(options) {
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    return isMobile ? (options.mobileDuration || 0.42) : (options.duration || 0.95);
  }

  function init(scope, selector, customOptions) {
    if (!window.gsap || !window.ScrollTrigger) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var root = scope || document;
    var revealSelector = selector || defaultSelector;
    var options = customOptions || {};
    var items = Array.prototype.slice.call(root.querySelectorAll(revealSelector)).filter(function(item) {
      return isVisible(item) && !preparedItems.has(item) && !animatedItems.has(item);
    });

    if (!items.length) return;

    gsap.registerPlugin(ScrollTrigger);

    items.forEach(function(item) {
      preparedItems.add(item);
    });

    gsap.set(items, {
      autoAlpha: 0,
      y: options.y || 40,
      scale: options.scale || 0.98
    });

    ScrollTrigger.batch(items, {
      start: options.start || 'top 88%',
      once: true,
      onEnter: function(batch) {
        gsap.to(batch, {
          autoAlpha: 1,
          y: 0,
          scale: 1,
          duration: getDuration(options),
          ease: options.ease || 'power3.out',
          stagger: options.stagger || 0.16,
          overwrite: true,
          onComplete: function() {
            batch.forEach(function(item) {
              animatedItems.add(item);
            });
          }
        });
      }
    });

    ScrollTrigger.refresh();
  }

  function refresh() {
    if (window.ScrollTrigger) {
      ScrollTrigger.refresh();
    }
  }

  window.mxStaggeredReveal = {
    init: init,
    refresh: refresh
  };
})();
